import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NavController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class SentryInterceptorService implements HttpInterceptor {
  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            // Détection de la route /users/me
            if (req.url.includes('/users/me')) {
              const user = event.body;

              if (user && user.id) {
                Sentry.setUser({
                  id: user.id,
                  email: user.email,
                });
              }
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 400 || error.status >= 500) {
            Sentry.captureEvent({
              level: ((error.status >= 500) ? 'error' : 'warning'),
              message: `HTTP ${error.status} on ${req.method} ${req.url}`,
              extra: {
                url: req.url,
                method: req.method,
                status: error.status,
                statusText: error.statusText,
                errorMessage: error.message,
                requestBody: req.body,
                responseBody: error.error,
              }
            });
          }
        }
      })
    );
  }
}
